/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
import React, { useCallback } from 'react';

// https://github.com/gregberge/react-merge-refs/issues/5#issuecomment-643341631
export default function useMergedRefs<T = unknown>(
  refs: Array<React.MutableRefObject<T> | React.LegacyRef<T>>,
): React.RefCallback<T> {
  return useCallback((current: T) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(current);
      } else if (ref && !Object.isFrozen(ref)) {
        (ref as React.MutableRefObject<T | null>).current = current;
      }
    });
  }, refs);
}
